import React, { useState, useEffect } from 'react';
import ShareIcon from '../assets/icons/ShareIcon';
import FilterDropdown from './FilterDropdown';
import { useFilters } from '../contexts/FiltersContext';

const DashboardTabSwitcher = ({
    tabs = [],
    activeTab,
    onTabChange,
    showShareButton = true,
    showFilter = false,
    onShare,
    className = '',
    tabClassName = '',
    activeTabClassName = '',
    shareButtonClassName = '',
    children,
}) => {

    const { selectedPrimary, setSelectedPrimary, filterOptions } = useFilters()

    const handleApplyFilters = (newSelected) => {
        setSelectedPrimary(newSelected);
    };

    return (
        <div className={`w-full ${className} `}>

            <div className="flex items-center mb-4 justify-between">
                <div className="flex items-center space-x-4">
                    {tabs.map((tab, index) => (
                        <button
                            key={index}
                            onClick={() => onTabChange(tab.value, tab?.isFilterRequired)}
                            className={`px-1 leading-9 text-sm font-medium transition-all duration-200 ${activeTab === tab.value
                                    ? `text-textBrandBlue border-b-2 border-textBrandBlue ${activeTabClassName}`
                                    : `text-textPrimary hover:text-neutral400 ${tabClassName}`
                                }`}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>

                <div className='flex items-center' >
                    {showFilter && <div>
                        <div className="">
                            <FilterDropdown
                                onApply={handleApplyFilters}
                                selectedPrimary={selectedPrimary}
                                label={filterOptions.label}
                                options={filterOptions.options}
                            />
                        </div>
                    </div>}


                    {/* {showShareButton && (
                    <button
                        onClick={onShare}
                        className={`p-2 text-tabTextColor hover:text-statsLabelLightColor transition-colors duration-200 ${shareButtonClassName}`}
                        title="Share Dashboard"
                    >
                        <ShareIcon />
                    </button>
                )} */}

                </div>

            </div>


            <div className="w-full">
                {children}
            </div>
        </div>
    );
};

export default DashboardTabSwitcher; 